/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .app-btn[_ngcontent-%COMP%]{color:#459fed;text-align:center;text-decoration:none;cursor:pointer}[_nghost-%COMP%]   .app-btn.default[_ngcontent-%COMP%]:hover{text-decoration:underline}[delete][_nghost-%COMP%]   .app-btn[_ngcontent-%COMP%]:hover{color:#ee0f2b}"];
export { styles as styles };
